import React from 'react';
import { useDispatch } from 'react-redux';
import { editCover, setConfirmDeleteMember } from '@om/redux/actions/easiplusFuneralPlan/quote';
import { OmLabeledValueSummary, OmEfpFamilyMemberCard } from '@om/component-library-react';

const BenefitsCard = ({
    id,
    cashback,
    premiumPaidUp,
    onDelete,
    deleteEnabled = false,
    onEdit,
}) => {

    return (
        <OmEfpFamilyMemberCard
            expanded
            editEnabled
            deleteEnabled={deleteEnabled}
            addDetailsEnabled
            cardId={id}
            onEditDetailsClicked={onEdit}
            onPopupModal={onDelete}
        >
            <h6 className="strong small no-top-margin no-bottom-margin" slot="family-member-card-heading">
                Benefits details
            </h6>
            <div style={{display:'flex',gap:'10px',padding:'0 0 0 20px',justifyContent:'space-between',width:'calc(100% - 20px)'}} slot="family-member-card-body">
                <OmLabeledValueSummary label="CASHBACK" value={cashback} />
                {/* <OmLabeledValueSummary label="PREMIUM PAID UP" value={premiumPaidUp} /> */}
            </div>
        </OmEfpFamilyMemberCard>
    );
};

export default BenefitsCard;
